export * from './WordingsRepository';
export * from './WordingsDTO';
